import BuyList from './buyList';

export default BuyList;



// WEBPACK FOOTER //
// ./src/components/cards/buyList/index.js